module.exports = __webpack_public_path__ + "img/H15-3.f77f43f3.jpg";